export const SETTINGS_RECEIVED = 'SETTINGS_RECEIVED'
export const SETTINGS_UNLOADED = 'SETTINGS_UNLOADED'
